
  export default {
    name: 'SectionHeadlineWithTextAndNumbers',
    components: {
      StatisticsNumber: () => import('@/components/elements/StatisticsNumber'),
    },
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    serverCacheKey: function (props) {
      return 'section-headline-with-text-and-numbers-' + props.section.id;
    },
    methods: {
      columnSizes(index) {
        let mobileColumn;
        if (
          this.$vuetify.breakpoint.width <=
            this.$vuetify.breakpoint.thresholds.sm &&
          this.section.numbers.length % 2 !== 0 &&
          index < this.section.numbers.length - 1
        ) {
          mobileColumn = 6;
        } else if (
          this.$vuetify.breakpoint.width <=
            this.$vuetify.breakpoint.thresholds.sm &&
          this.section.numbers.length % 2 !== 0 &&
          index === this.section.numbers.length - 1
        ) {
          mobileColumn = 12;
        } else if (
          this.$vuetify.breakpoint.width <=
            this.$vuetify.breakpoint.thresholds.sm &&
          this.section.numbers.length % 2 === 0
        ) {
          mobileColumn = 6;
        }
        return this.$vuetify.breakpoint.width >
          this.$vuetify.breakpoint.thresholds.sm
          ? ''
          : mobileColumn;
      },
    },
  };
